import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  AFFILIATE_PARTNERSHIP_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';
import useStaticPageConfig from '@modules/static-pages/composables/useStaticPageConfig';

import {
  TRANSLATION_GROUP_STATIC_PAGES,
} from './constants';
import {
  getTranslationKeys,
} from './translations';

export class StaticPagesModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    const { configAsEntries } = useStaticPageConfig();
    for (const [, config] of configAsEntries) {
      router.addAffiliateRoute({
        name: config.routeName,
        path: config.path,
        permission: config.permission,
        component: () => import('./pages/StaticPage/StaticPage.vue'),
      });
    }
  }

  addMenu(menu: AppMenu): void {
    const { configAsEntries } = useStaticPageConfig();
    const { getTPath } = useI18n();

    let index = 1;
    for (const [, config] of configAsEntries) {
      menu.addChildAffiliateMenuItem(AFFILIATE_PARTNERSHIP_MENU_ITEM, {
        caption: getTPath(TRANSLATION_GROUP_SIDEBAR, config.translationShortcodeSidebar),
        to: {
          name: config.routeName,
        },
        permission: config.permission,
        id: config.routeName,
        order: index * 10,
      });
      index += 1;
    }
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_STATIC_PAGES, getTranslationKeys);
  }
}
